import "./TogglePadrao.css";
import { useState, useEffect } from "react";

const TogglePadrao = ({
  checked = false,
  value,
  onChange,
  textoAtivo = "ATIVO",
  textoInativo = "INATIVO",
  label = "",
  disabled = false,
}) => {
  const isControlled = value !== undefined;
  const [ativo, setAtivo] = useState(isControlled ? value : checked);

  useEffect(() => {
    if (!isControlled) return;
    setAtivo(value);
  }, [value, isControlled]);

  const handleToggle = () => {
    if (disabled) return;
    if (isControlled) {
      if (onChange) onChange(!value);
    } else {
      setAtivo((prev) => {
        const novoValor = !prev;
        if (onChange) onChange(novoValor);
        return novoValor;
      });
    }
  };

  return (
    <div className="toggle-externo-col">
      {label && <span className="toggle-main-label">{label}</span>}
      <div
        className={`toggle-container ${(isControlled ? value : ativo) ? "ativo" : "inativo"}${disabled ? " disabled" : ""}`}
        onClick={handleToggle}
        style={disabled ? { cursor: "not-allowed", opacity: 0.6 } : {}}
      >
        <div className="toggle-switch">
          <div className="toggle-indicador" />
        </div>
        <span className="toggle-label">{(isControlled ? value : ativo) ? textoAtivo : textoInativo}</span>
      </div>
    </div>
  );
};

export default TogglePadrao;
